<template>
	<div>
		<div class="cart__products">
			<cart-item v-if="checkItems" v-for="item in cartItems" :item="item" :key="item.id + '-' + item.currentProp.vol" v-on:updateCount="onUpdateItem" v-on:removeFromCart="onRemoveItem"></cart-item>
			<h3 v-if="!checkItems">Добавьте товары в корзину</h3>
		</div>
		<div class="cart__wrap" v-if="checkItems">
			<!--<div class="cart__pack">
				<h2>Выберите упаковку</h2>
				<pack :items="packs" v-on:changePack="setPackPrice"></pack>
			</div>-->
			<div class="cart__profile" v-if="checkItems">
				<h2>Оформление заказа</h2>
				<order :total="total.cart + total.delivery"></order>
			</div>

			<div class="cart__price cprice">
				<h2>Стоимость</h2>

				<div class="uk-grid-small cprice__item" uk-grid>
					<div class="uk-width-expand" uk-leader>Товары:</div>
					<div class="cprice__price">{{ total.cart }} ₽</div>
				</div>

				<!--<div class="uk-grid-small cprice__item" uk-grid>
					<div class="uk-width-expand" uk-leader>Упаковка:</div>
					<div class="cprice__price">{{ total.pack }} ₽</div>
				</div>-->

				<div class="uk-grid-small cprice__item" uk-grid>
					<div class="uk-width-expand" uk-leader>Доставка:</div>
					<div class="cprice__price">{{ total.delivery }} ₽</div>
				</div>

				<hr>

				<div class="uk-grid-small cprice__item" uk-grid>
					<div class="uk-width-expand" uk-leader>Общая стоимость:</div>
					<div class="cprice__price cprice__price--total">{{ total.cart + total.delivery | cifer }} ₽</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import cartItem from './cart-item'
  import order from './order'
  import pack from './pack'

  export default {
    name: "big-cart",
    data() {
      return {
        cartItems: '',
	      packPrice: '',
        total: {
          cart: 0,
          pack: 0,
          delivery: 0
        }
      }
    },
    components: { cartItem, order, pack },
    props: {
      url: '',
      items: '',
      packs: '',
    },
    computed: {
      checkItems() {
        if (Object.keys(this.cartItems).length == 0 || $.isEmptyObject(this.cartItems)) {
          return false;
        } else {
          return true;
        }
      }
    },
	  watch: {
      'cartItems': 'setItemsPrice'
	  },
    methods: {
      setPackPrice(price){
        this.total.pack = price*1;
      },
      setItemsPrice(){
        let price = 0;
        for (let key in this.cartItems) {
          price = price*1 + this.cartItems[key].total*1;
        }
        this.total.cart = price;
      },
      setDeliveryPrice(){},
      onRemoveItem(data) {
        Vue.delete(this.cartItems, data);
      },
      onUpdateItem(data){
        this.cartItems[data.retId] = data;
        this.setItemsPrice();
      }
    },
    mounted() {
      if(this.items){
        this.cartItems = this.items;
      }
      this.setItemsPrice();
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/polza/src/js/components/commerce/big-cart.vue